import { useSelector } from 'react-redux'

import { selectAllCustomFields } from '../customFieldsSlice'
import { selectAllCustomFieldOptions } from '../customFieldOptionsSlice'
import { selectAllCustomFieldsSettings } from '@user/store/customFieldSettings'
import { useMemo } from 'react'
import {
  CustomField,
  CustomFieldOption,
  sortArrayByArray,
} from '@sales-center/common'
import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'

export type CustomFieldData = {
  orderedCustomFields: CustomField[]
  customFields: CustomField[]
  customFieldOptions: CustomFieldOption[]
  customSettings: ICustomFieldFormSetting[]
}

export function useSelectCustomFieldData(): CustomFieldData {
  const customFields = useSelector(selectAllCustomFields)
  const customFieldOptions = useSelector(selectAllCustomFieldOptions)

  const customSettings = useSelector(selectAllCustomFieldsSettings)
  //TODO:test this with empty array
  const orderedCustomFields = useMemo(() => {
    const sortedIds = [...customSettings]
      .sort((a, b) => a.order - b.order)
      .map((s) => s.customFieldId)
    return sortArrayByArray(customFields, sortedIds, (field) => field.id)
  }, [customFields, customSettings])

  return {
    orderedCustomFields,
    customFields,
    customFieldOptions,
    customSettings,
  }
}
